import React, { Suspense } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { auth0Domain, auth0ClientId, auth0_params } from '@modul-connect/shared/config'
import { Auth0Provider } from '@auth0/auth0-react'
import PortalLoggedIn, { LoadingDisplay } from './pages/portal-logged-in/portal-logged-in'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { connect } from 'react-redux'
import { useAuth0 } from '@auth0/auth0-react'
import { LogoutLandingPage } from './pages/logout-callback/logoutCallback'
import { sec } from '@modul-connect/shared/auth0/auth0Helper'
import { userIsLoggedIn } from './state/actions/users'
import { ThemeProvider } from '@mui/material'
import theme from '@modul-connect/shared/theme'
import { useTranslation } from 'react-i18next'
import moment from "moment";
import "moment/locale/sv";
import "moment/locale/en-gb";

const Loader = () => (
  <div>
    loading..
  </div>
)

const App = ({ notifications, userIsLoggedIn }) => (
  <Suspense fallback={<Loader/>}>
    <AppPage notifications={notifications} userIsLoggedIn={userIsLoggedIn}/>
  </Suspense>
)

const AppPage = ({ notifications, userIsLoggedIn }) => {
  const navigate = useNavigate()

  const unseenNotificationsCount = notifications?.filter(n => !n?.seen)?.length

  const {t} = useTranslation()
  return (
    <Auth0Provider
      navigate={navigate}
      domain={auth0Domain()}
      clientId={auth0ClientId()}
      cacheLocation='localstorage'
      onRedirectCallback={() => userIsLoggedIn()}
      authorizationParams={{
        redirect_uri: auth0_params.redirectUri,
        audience: auth0_params.audience
      }}
    >
      <Helmet>
      <title>{(unseenNotificationsCount ? `(${unseenNotificationsCount}) ` : '') + 'Modul-Connect Portal'}</title>
      </Helmet>

      <LocalizationProvider dateAdapter={AdapterLuxon}>
        <ThemeProvider theme={theme.mui}>
          <Portal />
        </ThemeProvider>
      </LocalizationProvider>

    </Auth0Provider>
  )
}

const Portal = () => {
  const [isLoggedIn, setIsLoggedIn] = React.useState(false)
  const auth0 = useAuth0()

  const { i18n } = useTranslation();

  React.useEffect(() => {
    moment.locale(i18n.language.startsWith("sv") ? "sv" : "en-gb")
  }, [i18n.language])
  const tryingToAccessSpecificPage = window.location.pathname !== '/logout' && window.location.pathname !== '/login_success'

  React.useEffect(() => {
    if (auth0.isLoading) return
    if (auth0.isAuthenticated) {
      sec.setAccessTokenSilently(auth0.getAccessTokenSilently)
      if (auth0.user) {
        setIsLoggedIn(true)
        return
      }
    }
    setIsLoggedIn(false)
  }, [auth0])

  const isLoading = !auth0 || auth0.isLoading

  return isLoading ? <LoadingDisplay /> : (isLoggedIn || tryingToAccessSpecificPage) ? <PortalLoggedIn/> : <LogoutLandingPage />
}

const mapStateToProps = ({
  notifications
}) => ({
  notifications
})

const mapDispatchToProps = dispatch => ({
  userIsLoggedIn: () => dispatch(userIsLoggedIn()),
})

export default connect(mapStateToProps, mapDispatchToProps) (App)
